module.exports = __webpack_public_path__ + "static/media/translate.0fda20f2.png";